import { render, staticRenderFns } from "./SysBigdataModal.vue?vue&type=template&id=a93102a2&"
import script from "./SysBigdataModal.vue?vue&type=script&lang=js&"
export * from "./SysBigdataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports